import { useState, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Label } from '@/components/ui/label';
import { WarehouseItem, useUpdateWarehouseItem } from '@/hooks/warehouse';
import { useOrganizations } from '@/hooks/useOrganizations';

interface EditWarehouseItemModalProps {
  isOpen: boolean;
  onClose: () => void;
  warehouseItem: WarehouseItem | null;
}

const EditWarehouseItemModal = ({
  isOpen,
  onClose,
  warehouseItem,
}: EditWarehouseItemModalProps) => {
  const [organizationId, setOrganizationId] = useState<string>('');
  const { data: organizations = [] } = useOrganizations();
  const { mutate: updateItem, isPending } = useUpdateWarehouseItem();

  useEffect(() => {
    if (warehouseItem) {
      setOrganizationId(warehouseItem.organization_id || '');
    }
  }, [warehouseItem]);

  const handleSave = () => {
    if (!warehouseItem || !organizationId) return;

    updateItem(
      {
        id: warehouseItem.id,
        organization_id: organizationId,
      },
      {
        onSuccess: () => {
          onClose();
        },
      }
    );
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Editar Item del Almacén</DialogTitle>
          <DialogDescription>
            {warehouseItem?.product?.name || 'Producto'}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="organization">Organización</Label>
            <Select value={organizationId} onValueChange={setOrganizationId}>
              <SelectTrigger id="organization">
                <SelectValue placeholder="Selecciona una organización" />
              </SelectTrigger>
              <SelectContent>
                {organizations.map((org) => (
                  <SelectItem key={org.id} value={org.id}>
                    {org.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={handleClose} disabled={isPending}>
            Cancelar
          </Button>
          <Button onClick={handleSave} disabled={isPending || !organizationId}>
            {isPending ? 'Guardando...' : 'Guardar'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default EditWarehouseItemModal;
